import DocumentImporterConfiguration from "../payslips/services/model/DocumentImporterConfiguration";
import {
  SupportedDocumentAttributes,
  SupportedFeatures,
} from "../payslips/services/model/FeatureConfiguration";

export const TimesheetJourneyConfiguration: DocumentImporterConfiguration = {
  document_type: SupportedFeatures.TIMESHEETS,
  document_name: "Timesheet",
  document_name_lower_case: "timesheet",
  document_name_plural: "Timesheets",
  document_name_plural_lower_case: "timesheets",
  main_page_route: "",
  attributes: [
    SupportedDocumentAttributes.START_AND_END_PERIOD,
    SupportedDocumentAttributes.DISTRIBUTION_DATES,
    SupportedDocumentAttributes.BATCH_NAME,
  ],
};
